import React from "react";
import { lang } from "../Helpers/lang";


import $ from "jquery";
/*var Parser = require("html-react-parser");
var base64 = require("base-64");*/

/* stripslashes  */
export const stripslashes = function(str) {
  str = str.replace(/\\'/g, "'");
  str = str.replace(/\\"/g, '"');
  str = str.replace(/\\0/g, "\0");
  str = str.replace(/\\\\/g, "\\");
  return str;
};

/* Random ID  */
export const randomId = function() {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 50; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

/* Call image */
/*export const callImage = function(image_source,image,width,height,timthumb,imageTag = 'Yes') {
    
    var imagesource='';
        
        if(image!==null && image!==''){
            imagesource = timthumb+image_source+"/"+image+"&w="+width+"&h="+height+"&q=80";
        }else{
            imagesource = noimage;
        }
        if(imageTag === 'Yes'){
            return (<img src={imagesource} alt="" width={width} height={height} />);
        }else{
            return imagesource;
        }
    
};*/



/* hide Loader */
export const hideLoader = function(divRef, type) {
  if (type === "class") {
    $("." + divRef).removeClass("loader-main-cls");
    $("." + divRef)
      .find(".loader-sub-div")
      .remove();
  } else {
    $("#" + divRef).removeClass("loader-main-cls");
    $("#" + divRef)
      .find(".loader-sub-div")
      .remove();
  }
};



/* time conversion  */
export const timeToConv12 = function(time24) {
  var ts = time24;
  if (ts !== "" && typeof ts !== "undefined") {
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? "0" + h : h;
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
  }
  return ts;
};

/* Date conversion  */
export const getOrderDateTime = function(dateTxt, TatTxt) {
  var dateStr = new Date();
  var TatTxtVl =
    TatTxt !== "" && typeof TatTxt !== "undefined" ? parseInt(TatTxt) : 0;
  if (dateTxt !== "" && typeof dateTxt !== "undefined") {
    dateStr = dateTxt;
  } else {
    var CurrentDate = new Date();
    CurrentDate.setMinutes(CurrentDate.getMinutes() + TatTxtVl);
    dateStr = CurrentDate;
  }

  return dateStr;
};

/* Date conversion  */
export const dateConvFun = function(dateTxt, type) {
  var dateStr = dateTxt;
  if (dateStr !== "" && typeof dateStr !== "undefined") {
    var newDateTxtone = dateTxt.replace(/-/g, "/");
    var todayTime = new Date(newDateTxtone);
    var month = todayTime.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    var day = todayTime.getDate();
    day = day > 9 ? day : "0" + day;
    var year = todayTime.getFullYear();

    if (type === 1) {
      dateStr = day + "/" + month + "/" + year;
    } else if (type === 2) {
      dateStr = day + "-" + month + "-" + year;
    }
  }

  return dateStr;
};

/* Date conversion  */
export const getTimeFrmDate = function(timeTxt, type) {
  var timeStr = timeTxt;
  if (timeStr !== "" && typeof timeStr !== "undefined") {
    var newtimeStr = timeStr.replace(/-/g, "/");
    var todayTime = new Date(newtimeStr);
    var hours = todayTime.getHours();
    var minut = todayTime.getMinutes();

    hours = parseInt(hours) < 10 ? "0" + hours : hours;
    minut = parseInt(minut) < 10 ? "0" + minut : minut;

    if (type === 1) {
      timeStr = hours + " : " + minut;
    } else if (type === 2) {
      timeStr = hours + ":" + minut;
      timeStr = timeToConv12(timeStr);
    }
  }

  return timeStr;
};

export const scrollToTopValidate = function() {
  if ($(".errorspan").length > 0) {
    $("html, body").animate(
      {
        scrollTop: $(".errorspan").offset().top - 190
      },
      500
    );
  }
};
export const scrollToTop = function() {
  $("html, body").animate(
    {
      scrollTop: $("body").offset().top - 150
    },
    1000
  );
};


export const CheckAuth = function() {
  if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
    }
};


export const LoadingSec = <div className="loading loading-h-200"></div>;


export const PageTitle = function(title) {
  let PageTitle = "";
  if (title !== "") {
    PageTitle += title + " | ";
  }
  PageTitle += lang.common.title;
  return PageTitle;
};



export const Capitalize= function (str){
  if(str!=undefined&&str!=null&&str!='')
  {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }else{
    return false;
  }

}